import React from 'react'
import Link from './Link'

type Props = {
  children: React.ReactNode
  href?: string
}

const ColorLink = ({ children, href = '#' }: Props) => {
  return (
    <Link href={href} underline="on" indent="off" icon="off">
      {children}
    </Link>
  )
}

export default ColorLink
